import React from 'react';
import Utils from './../../Utils/Utility';
import moment from "moment-timezone";

export default class CustomerDetail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            customersData: [],
            chargeData: {},
        };

        // this.showCustomChargeModal =   this.showCustomChargeModal.bind(this);
        this.getCustomCharges         =   this.getCustomCharges.bind(this);
        this.orderDateTime            =   this.orderDateTime.bind(this);
        this.getTotalOrders           =   this.getTotalOrders.bind(this);
        this.getTotalAmount           =   this.getTotalAmount.bind(this);

    }

    componentWillMount() {
        this.setState({
            customersData  : this.props.customersData,
            activeLocation : this.props.activeLocation
        });
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps != null){
            this.setState({
                customersData: nextProps.customersData
            });
        }
    }

    getCustomCharges(customChargeObj){

        if (!Utils.isEmptyObj(customChargeObj)){
            // console.log("customChargeObj details: " + JSON.stringify(customChargeObj));
            if (!Utils.isEmptyObj(customChargeObj)){

                let comp = "";
                for (var key in customChargeObj) {
                    if (customChargeObj.hasOwnProperty(key)) {
                        let customChargefee = Utils.number2digit(customChargeObj[key]);
                        let fee = isNaN(customChargefee) ? Utils.number2digit(0) : Utils.number2digit(customChargeObj[key]);
                        comp += "<span>" + key+  "</span>" + ":" + "<span class='pull-right'>" + " $"+ fee + "</span>" + "<br/>";
                    }
                }

                // return comp;
                return <div dangerouslySetInnerHTML={{__html: comp}} />;

            }

        }
    }

    orderDateTime(orderDate){
        if (!Utils.isEmptyObj(orderDate)){
            let lastOrderDate = moment(orderDate.iso);
            // let date = moment(lastOrderDate).format("Do MMM, YYYY, h:mm A");
            let date = moment(lastOrderDate).format("MMM, YYYY");

            return date;
        }
    }

    getTotalOrders(obj){
        if (!Utils.isEmptyObj(obj)){
            let totalOrders = Utils.getNum(obj.deliveryOrders) + Utils.getNum(obj.pickupOrders)  + Utils.getNum(obj.dineInOrders);
            return totalOrders;
        }
    }

    getTotalAmount(obj){
        if (!Utils.isEmptyObj(obj)){
            let totalAmount = Utils.getNum(obj.totalDeliveryAmount) + Utils.getNum(obj.totalPickupAmount)  + Utils.getNum(obj.totalDineInAmount);
            totalAmount = Utils.number2digit(totalAmount);
            return totalAmount;
        }
    }

    render() {
        const customersObj = this.state.customersData;
        const customersData = customersObj.customerDetails;

        return (
            <div className="section order-success-pg">
                <div className="container" style={{maxWidth: '100%'}}>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 modal-order-container">

                            <div className="row">
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className="">
                                        <div className='mt-10 mb-10'>
                                            <div className={"col-sm-6"}>
                                                <div className={"customer-container"}>
                                                    <h4 className="text-red order-type-details"><b>Customer Details</b></h4>
                                                    <span>{customersData.customerName}</span> <br />
                                                    <span>{customersData.customerEmail}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='mt-10 mb-10 order-pr'>
                                            <div className={"col-sm-6 order-customer-container"}>
                                                <div className={"customer-detail-container"}>
                                                    <h4 className="text-red order-type-details"><b>Last Order</b></h4>
                                                    <span>#{customersData.lastOrderNum}</span> <br />
                                                    <span>{this.orderDateTime(customersData.lastOrderDate)}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className="order_border box-sizing">
                                        <div className='mt-10 mb-10'>
                                            <div className={"col-sm-6"}>
                                                <div className="order-qt">
                                                    <h4 className="text-red order-type-details"><b>Total Order Details</b></h4>
                                                    <div className={"order-detail-container mb-10"}>
                                                        {!Utils.isEmpty(customersData.pickupOrders) ? (
                                                            <div>
                                                                <span>Total Pickup: </span>
                                                                <span className="pull-right"> {customersData.pickupOrders}</span><br/>
                                                            </div>

                                                        ) : null}

                                                        {!Utils.isEmpty(customersData.deliveryOrders) ? (
                                                            <div>
                                                                <span>Total Delivery: </span>
                                                                <span className="pull-right"> {customersData.deliveryOrders}</span><br/>
                                                            </div>

                                                        ) : null}

                                                        {!Utils.isEmpty(customersData.dineInOrders) ? (
                                                            <div>
                                                                <span>Total Dinein: </span>
                                                                <span className="pull-right">  {customersData.dineInOrders}</span><br/>
                                                            </div>

                                                        ) : null}

                                                        <div className="order-total-container">
                                                            <span className="mt-10"><b>Total Orders: </b></span>
                                                            <span className="pull-right"><b>{this.getTotalOrders(customersData)}</b></span>
                                                        </div>
                                                    </div>

                                                    {/*<h5 className={"mt-10"}><b>Total Orders: {this.getTotalOrders(customersData)}</b></h5>*/}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='mt-10 mb-10 order-pr'>
                                            <div className={"col-sm-6"}>
                                                <div className={"customer-detail-container"}>
                                                    <h4 className="text-red order-type-details"><b>Total Amount Spent</b></h4>

                                                    {!Utils.isEmpty(customersData.totalPickupAmount) ? (
                                                        <div>
                                                            <span>Total Pickup: </span>
                                                            <span className="pull-right"> ${Utils.number2digit(customersData.totalPickupAmount)}</span><br/>
                                                        </div>

                                                    ) : null}

                                                    {!Utils.isEmpty(customersData.totalDeliveryAmount) ? (
                                                        <div>
                                                            <span >Total Delivery:</span>
                                                            <span className="pull-right">${Utils.number2digit(customersData.totalDeliveryAmount)} </span><br/>
                                                        </div>

                                                    ) : null}

                                                    {!Utils.isEmpty(customersData.totalDineInAmount) ? (
                                                        <div>
                                                            <span >Total Dinein: </span>
                                                            <span className="pull-right">${Utils.number2digit(customersData.totalDineInAmount)}</span><br/>
                                                        </div>

                                                    ) : null}

                                                    <div className="order-total-container">
                                                        <span className={"mt-10"}><b>Total Amount: </b></span>
                                                        <span className="pull-right"><b> ${this.getTotalAmount(customersData)} </b></span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {!Utils.isEmptyObj(customersData.charge) ? (
                                    <div className="row">
                                        <div className="container" style={{maxWidth: '100%'}}>
                                            <div className="order_border box-sizing">
                                                <div className='mt-10 mb-10'>
                                                    <div className={"col-sm-11 order-container"}>
                                                        <h4 className="text-red order-type-details"><b>Custom Charges</b></h4>
                                                        <div className={"order-detail-container"}>
                                                            <span className={""}>{this.getCustomCharges(customersData.charge)}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            ) : null }

                        <div className="row">
                            <div className="container" style={{maxWidth: '100%'}}>
                                <div className={!Utils.isEmpty(customersData.totalTipPaid) || !Utils.isEmpty(customersData.totalCouponUsed) ? "order_border box-sizing" : "none"}>
                                        <div className={!Utils.isEmptyObj(customersData.charge) ? "col-sm-11 coupon-qt" : "col-sm-6 coupon-qt"}>
                                            <div className={"order-detail-container"}>

                                                {!Utils.isEmpty(customersData.totalTipPaid) ? (
                                                    <div>
                                                        <span>Total Tip: </span>
                                                        <span className="pull-right">${Utils.number2digit(customersData.totalTipPaid)}</span><br/>
                                                    </div>

                                                ) : null}

                                                {!Utils.isEmpty(customersData.totalCouponUsed) ? (
                                                    <div>
                                                        <span>Coupon Used: </span>
                                                        <span className="pull-right">{customersData.totalCouponUsed}</span><br/>
                                                    </div>

                                                ) : null}

                                            </div>
                                        </div>
                                        <div className={!Utils.isEmptyObj(customersData.charge) ? "col-sm-1" : "col-sm-6"}></div>
                                    </div>
                                </div>
                            </div>


                            <div className="row mb-10">
                                <div className="container" style={{maxWidth: '100%'}}>
                                    <div className={"cart_border"}>
                                        {/*<h4 className="text-red pt-1 mb-0 text-uppercase text-center"><b>***Freshbytes***</b></h4>*/}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/order/customer-detail.jsx